import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";

interface IProps {
  setIsShowLogout: () => void;
}

const Header: React.FC<IProps> = ({ setIsShowLogout }) => {
  const [userInfo, setUserInfo] = useState<{ userName: string; coins: number } | null>(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        const info = {
          coins: data.coins,
          role: data.role,
          userName: data.username,
        };
        localStorage.setItem("user_info", JSON.stringify(info));
        setUserInfo({ userName: info.userName, coins: info.coins });
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <div className="w-full h-[80px]">
      <header
        className="menu-lobby py-3"
        style={{
          backgroundColor: "#250000",
          borderBottom: "2px solid #ff0000",
        }}
      >
        <nav className="navbar navbar-expand-lg navbar-dark flex items-center justify-between md:justify-around px-4 gap-4 relative">
          <a className="navbar-brand flex items-center" href="/">
            <img
              className="!w-[180px] md:!w-[220px] lg:!w-[260px]"
              src="/assets/logo-nohu.png"
              alt="KINGNOHU"
            />
          </a>

          {/* Desktop layout: 3 item hiển thị trực tiếp */}
          {!isMobile && (
            <div className="flex items-center gap-4 text-white">
              {userInfo && (
                <>
                  <div
                    className="flex items-center gap-3 px-3 py-1 rounded-full"
                    style={{
                      backgroundColor: "#4b0000",
                      border: "1px solid #ff4d4d",
                    }}
                  >
                    <img
                      src="/assets/user-icon.png"
                      alt="user"
                      className="w-8 h-8"
                    />
                    <span className="text-base font-semibold">
                      {userInfo.userName}
                    </span>
                  </div>
                  <div
                    className="flex items-center gap-3 px-3 py-1 rounded-full"
                    style={{
                      backgroundColor: "#4b0000",
                      border: "1px solid #ff4d4d",
                    }}
                  >
                    <img
                      src="/assets/coins.png"
                      alt="coins"
                      className="w-8 h-8"
                    />
                    <span className="text-base font-semibold">
                      {userInfo.coins.toLocaleString("vi-VN")}
                    </span>
                  </div>
                </>
              )}
              <button
                type="button"
                onClick={setIsShowLogout}
                className="flex items-center gap-3 text-white font-semibold px-3 py-1 rounded-full"
                style={{
                  background: "linear-gradient(90deg, #dc2626, #ea580c)",
                  border: "none",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    borderRadius: "9999px",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <img
                    src="/assets/logout.png"
                    alt="logout"
                    className="w-5 h-5"
                  />
                </span>
                <span className="text-base font-semibold">Đăng xuất</span>
              </button>
            </div>
          )}

          {/* Mobile layout: icon navbar-icon mở menu 3 item */}
          {isMobile && (
            <>
              <button
                type="button"
                onClick={() => setIsMenuOpen((prev) => !prev)}
                className="flex items-center justify-center w-10 h-10 rounded-md border border-red-600 bg-black/40"
              >
                <img
                  src="/assets/navbar-icon.png"
                  alt="menu"
                  className="w-8 h-8 object-contain"
                />
              </button>

              {isMenuOpen && (
                <div
                  className="absolute right-4 top-[64px] z-50 flex flex-col gap-2 text-white px-3 py-3 rounded-lg"
                  style={{
                    backgroundColor: "rgba(17, 17, 17, 0.95)",
                    border: "1px solid #ff4d4d",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.8)",
                    minWidth: 220,
                  }}
                >
                  {userInfo && (
                    <>
                      <div className="flex items-center gap-2 px-2 py-1 rounded-md bg-[#4b0000] border border-red-700">
                        <img
                          src="/assets/user-icon.png"
                          alt="user"
                          className="w-7 h-7"
                        />
                        <span className="text-sm font-semibold truncate">
                          {userInfo.userName}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 px-2 py-1 rounded-md bg-[#4b0000] border border-red-700">
                        <img
                          src="/assets/coins.png"
                          alt="coins"
                          className="w-7 h-7"
                        />
                        <span className="text-sm font-semibold">
                          {userInfo.coins.toLocaleString("vi-VN")}
                        </span>
                      </div>
                    </>
                  )}
                  <button
                    type="button"
                    onClick={() => {
                      setIsMenuOpen(false);
                      setIsShowLogout();
                    }}
                    className="flex items-center justify-center gap-2 text-white font-semibold px-3 py-2 rounded-md"
                    style={{
                      background: "linear-gradient(90deg, #dc2626, #ea580c)",
                      border: "none",
                    }}
                  >
                    <img
                      src="/assets/logout.png"
                      alt="logout"
                      className="w-5 h-5"
                    />
                    <span className="text-sm font-semibold">Đăng xuất</span>
                  </button>
                </div>
              )}
            </>
          )}
        </nav>
      </header>
    </div>
  );
};

export default Header;
